module.exports = __webpack_public_path__ + "static/media/call-primary.ba86e409.svg";